export { ConfirmationComponent } from './confirmation/confirmation.component';
export { PersonModalComponent } from './person/person-modal.component';
export { MerchantProfileComponent } from './merchant-profile/merchant-profile.component';
export { AddMerchantAccessUsersComponent } from './add-merchant-access-users/add-merchant-access-users.component';
export { SetMerchantIdComponent } from './set-merchant-id/set-merchant-id.component';
export { MerchantAccountTypeComponent } from './merchant-account-type/merchant-account-type.component';